import React from 'react';
import {MagnifyingGlassIcon} from "@radix-ui/react-icons";
import {useNavigate} from "react-router-dom";

function DetailBtn({uri, id}) {
    const navigate= useNavigate();
    return (
        <button
            style={{
                position: 'absolute',
                background: 'var(--main-bg-color)',
                zIndex: "5",
                width: "70px",
                top: '50%',
                height: 'calc(100% - 2px)',
                right: "-35px",
                transform: 'translate(-50%, -50%)',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
            }}
            onClick={() => navigate(uri)}
        >
            <MagnifyingGlassIcon className={'m-auto w-[30px] h-[30px]'}/>
        </button>
    );
}

export default DetailBtn;